import { Component, ElementRef, EventEmitter, Output, Renderer2 } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';

@Component({
  selector: 'app-brand-loading-animation',
  standalone: true,
  imports: [],
  templateUrl: './brand-loading-animation.component.html',
  styleUrl: './brand-loading-animation.component.scss'
})
export class BrandLoadingAnimationComponent {
  @Output() handleAnimationComplete = new EventEmitter;
  

  private numDots = 40;
  loadingText: string = '';

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.animateBricks();
    this.animateRipples();
    this.createDots();
    this.animateDots();
  }

  createDots() {
    const container = this.elRef.nativeElement.querySelector('#dot-container');
    for (let i = 0; i < this.numDots; i++) {
      const dot = this.renderer.createElement('div');
      this.renderer.addClass(dot, 'dot');
      this.renderer.appendChild(container, dot);
    }
  }

  animateDots() {
    anime({
      targets: '.dot',
      translateX: () => anime.random(-100, 100),
      translateY: () => anime.random(-100, 100),
      opacity: [1, 0],
      scale: [1, 0.2],
      easing: 'easeOutQuad',
      duration: 1200,
      delay: anime.stagger(30),
      loop: false
    });
  }

  animateLogoMark() {
    anime({
      targets: '#logo-mark',
      translateY: () => anime.random(-10, 10),
      translateX: () => anime.random(-10, 10),
      easing: 'easeInOutQuad',
      duration: 100,
      loop: 10,
      direction: 'alternate' 
    });
  }

  animateBricks() {
    anime({
      targets: '.brick',
      scale: [1, 0.01],
      opacity: [1, 0],
      easing: 'easeOutSine',
      duration: 50,
      delay: anime.stagger(10, { direction: 'reverse' }),
      loop: false,
    });
  }

  animateRipples() {
    anime({
      targets: '#ripple',
      scale: [0, 1.2],
      opacity: [0.7, 0],
      easing: 'easeOutQuad',
      duration: 1700,
      delay: 500,
      loop: false
    });

    anime({
      targets: '#ripple-two',
      scale: [0, 1.6],
      opacity: [0.7, 0],
      easing: 'easeOutQuad',
      duration: 2800,
      delay: 800,
      loop: false,
      complete: () =>  this.handleAnimationComplete.emit(),
    });
  }
}
